import { FastImageProps } from 'react-native-fast-image';

import { League } from '@/types/api.generated';

export type AllLeaguesItem = {
    id: string;
    label: string;
    image?: FastImageProps['source'];
    isOffseason?: boolean;
    disabled?: boolean;
};

export type AllLeaguesSection = {
    sport: string;
    data: AllLeaguesItem[];
};

export type AllLeaguesListItem =
    | { type: 'header'; key: string; label: string }
    | { type: 'league'; key: string; league: AllLeaguesItem }
    | { type: 'divider'; key: string };

// TODO: until the BE adds sport grouping to league configs
const LEAGUE_SPORT_MAP: Partial<Record<League, string>> = {
    [League.Nba]: 'Basketball',
    [League.Wnba]: 'Basketball',
    [League.Cbb]: 'Basketball',
    [League.Wcbb]: 'Basketball',
    [League.Nfl]: 'Football',
    [League.NflFullseason]: 'Football',
    [League.NflFullSeason]: 'Football',
    [League.NflPreseason]: 'Football',
    [League.Cfb]: 'Football',
    [League.Mlb]: 'Baseball',
    [League.Nhl]: 'Hockey',
    [League.Pga]: 'Golf',
    [League.Ufc]: 'MMA',
    [League.Atp]: 'Tennis',
    [League.Wta]: 'Tennis',
    [League.Epl]: 'Soccer',
    [League.Bun]: 'Soccer',
    [League.Ucl]: 'Soccer',
    [League.Mls]: 'Soccer',
    [League.Fwc]: 'Soccer',
    [League.L1f]: 'Soccer',
    [League.Llg]: 'Soccer',
    [League.Sea]: 'Soccer',
    [League.Wcc]: 'Soccer',
    [League.Cod]: 'Esports',
    [League.Csgo]: 'Esports',
    [League.Dota]: 'Esports',
    [League.Lol]: 'Esports',
    [League.RocketLeague]: 'Esports',
    [League.Valorant]: 'Esports',
};

export const buildLeagueSections = (items: AllLeaguesItem[], leagueIds: League[]): AllLeaguesSection[] => {
    const sectionMap = new Map<string, AllLeaguesItem[]>();

    items.forEach((item, index) => {
        const sport = LEAGUE_SPORT_MAP[leagueIds[index]] ?? 'Other';
        const existing = sectionMap.get(sport);
        if (existing) {
            existing.push(item);
        } else {
            sectionMap.set(sport, [item]);
        }
    });

    return Array.from(sectionMap.entries()).map(([sport, data]) => ({ sport, data }));
};

export const flattenLeagueSections = (sections: AllLeaguesSection[]): AllLeaguesListItem[] => {
    const items: AllLeaguesListItem[] = [];

    sections.forEach((section, index) => {
        if (index > 0) {
            items.push({ type: 'divider', key: `divider:${section.sport}` });
        }
        items.push({ type: 'header', key: `sport:${section.sport}`, label: section.sport });
        section.data.forEach(league => {
            items.push({ type: 'league', key: `league:${league.id}`, league });
        });
    });

    return items;
};
